import * as type from './types';

export const setPowerSearch = (amount) => async (dispatch) => {
  return dispatch({
    type: type.SET_POWER_SEARH,
    payload: { searchPower: amount },
  });
};

export const resetPowerSearch = (searchPower) => async (dispatch) => {
  console.debug('resetPowerSearch', { searchPower });
  return dispatch({
    type: type.SET_POWER_SEARH,
    payload: { searchPower },
  });
};

export const setAmulets = (amulets) => async (dispatch) => {
  window.localStorage.setItem('amulets', JSON.stringify(amulets));
  return dispatch({
    type: type.SET_AMULETS,
    payload: amulets,
  });
};

export const setRemembers = (remembers) => async (dispatch) => {
  window.localStorage.setItem('remembers', JSON.stringify(remembers));
  return dispatch({
    type: type.SET_REMEMBERS,
    payload: remembers,
  });
};

export const bossDefeated = (stageId) => async (dispatch) => {
  console.debug('bossDefeated', { stageId });
  return dispatch({
    type: type.BOSS_DEFEATED,
    payload: { stageId },
  });
};

export const stageCompleted = (twilightZoneId) => async (dispatch) => {
  return dispatch({
    type: type.STAGE_COMPLETED,
    payload: { twilightZoneId },
  });
};

export const setBossRanks = (bossRanks) => async (dispatch) => {
  return dispatch({
    type: type.GET_BOSS_RANKS,
    payload: bossRanks,
  });
};
